import React from "react";
import { Link } from "react-router-dom";
import Moment from "react-moment";

const NotificationItem = ({
  notification,
  setnotificationsOpen,
  deleteNotification,
}) => {
  return (
    <div
      className={notification.unread ? "notification green" : "notification"}
    >
      {notification.type === "giftedcourse" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
                alt="avatar"
              />
            </div>
          </Link>
          <div className="notification-text green">
            <div className="notification-type">
              <i className="fas fa-gift mx-5 green"></i>
              Gifted Course
            </div>
            <div className="notification-text-title">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. or ime
              monthly courses.
            </div>
            <div className="notification-user green">
              Gifted from {notification.firstname} {notification.lastname}
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 green"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times green"></i>
          </div>
        </div>
      )}
      {notification.type === "giftedsubscription" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
                alt="notification-avatar"
              />
            </div>
          </Link>
          <div className="notification-text green">
            <div className="notification-type">
              <i className="fas fa-gift mx-5 green"></i>
              Gifted Subscription
            </div>
            <div className="notification-text-title">
              One month subscription to Mentor Name or ime subscription
            </div>
            <div className="notification-user green">
              Gifted from {notification.firstname} {notification.lastname}
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 green"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times green"></i>
          </div>
        </div>
      )}
      {notification.type === "acceptedcasualrequest" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
                alt="noti-avatar"
              />
            </div>
          </Link>
          <div className="notification-text green">
            <div className="notification-type">
              <i className="fas fa-user-friends mx-5 green"></i>
              Accepted Friend Request
            </div>
            <div className="notification-text-title">
              <span className="green">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              added you as a Friend.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 green"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times green"></i>
          </div>
        </div>
      )}
      {notification.type === "follower" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
                alt="small-avatar"
              />
            </div>
          </Link>
          <div className="notification-text green">
            <div className="notification-type">
              <i className="fas fa-users mx-5 green"></i>
              New Follower
            </div>
            <div className="notification-text-title">
              <span className="green">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              followed you.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 green"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times green"></i>
          </div>
        </div>
      )}
      {notification.type === "friends" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
                alt="friend-avatar"
              />
            </div>
          </Link>
          <div className="notification-text green">
            <div className="notification-type">
              <i className="fas fa-user-friends mx-5 green"></i>
              Received Friend Request
            </div>
            <div className="notification-text-title">
              <span className="green">
                {notification.firstname} {notification.lastname}
              </span>{" "}
              sent you a Friend request.
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 green"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times green"></i>
          </div>
        </div>
      )}
      {notification.type === "expiringmentorsubscription" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
                alt="another-avi"
              />
            </div>
          </Link>
          <div className="notification-text green">
            <div className="notification-type">
              <i className="fas fa-user-check mx-5 green"></i>
              Expiring Subscription
            </div>
            <div className="notification-text-title">
              Your subscription to Mentor Name expires in number days.
              <span className="green cursor mx-5">Resubscribe</span>?
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 green"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times green"></i>
          </div>
        </div>
      )}
      {notification.type === "discussioninvite" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
                alt="discussion-avatar"
              />
            </div>
          </Link>
          <div className="notification-text green">
            <div className="notification-type">
              <i className="fas fa-video mx-5 green"></i>
              Live Discussion
            </div>
            <div className="notification-text-title">
              {notification.firstname} {notification.lastname} invited you to a
              live discussion
              <span className="green cursor mx-5">Join Now</span>
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 green"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times green"></i>
          </div>
        </div>
      )}
      {notification.type === "livestream" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
                alt="stream-avatar"
              />
            </div>
          </Link>
          <div className="notification-text green">
            <div className="notification-type">
              <i className="fas fa-video mx-5 green"></i>
              Live Stream
            </div>
            <div className="notification-text-title">
              {notification.firstname} {notification.lastname} just went live!
              <span className="green cursor mx-5">Watch Now</span>
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 green"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times green"></i>
          </div>
        </div>
      )}
      {notification.type === "sharedarticle" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
                alt="article-avatar"
              />
            </div>
          </Link>
          <div className="notification-text green">
            <div className="notification-type">
              <i className="far fa-newspaper mx-5 green"></i>
              Shared Article
            </div>
            <div className="notification-text-title">
              {notification.firstname} {notification.lastname} shared
              Innovator's article with you.
              <span className="green cursor mx-5">View Now</span>
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 green"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times green"></i>
          </div>
        </div>
      )}
      {notification.type === "expiringsubscription" && (
        <div className="single-notification">
          <Link
            to={`/${notification.channelid}`}
            onClick={() => setnotificationsOpen(false)}
          >
            <div className="notif-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${notification.avatar}`}
                className="notif-avi"
                alt="sub-avatar"
              />
            </div>
          </Link>
          <div className="notification-text green">
            <div className="notification-type">
              <i className="fas fa-medal mx-5 green"></i>
              Expiring Subscription
            </div>
            <div className="notification-text-title">
              Your subscription
              <span className="green mx-5">Subscription Name</span>
              expires in 7 days. Would you like to
              <span className="green mx-5 cursor">Renew</span>?
            </div>
            <div className="notification-date">
              <i className="far fa-clock mx-5 green"></i>
              <Moment format="MM/DD/YYYY">{notification.date}</Moment>
            </div>
          </div>
          <div
            onClick={() => deleteNotification(notification._id)}
            className="remove-notification"
          >
            <i className="fas fa-times green"></i>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationItem;
